module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../../node_modules/happypack/loader.js?id=jsx!./DeliveryListView.js"));
	}, "DeliveryListView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=DeliveryListView!./src/pages/Shop/Member/TradeManage/OrderList/Detail/DeliveryList/DeliveryListView.js
// module id = 1013
// module chunks = 438